import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import i18n from 'i18n';
import BoxWhite from 'components/BoxWhite';
import Categories from 'components/Categories';
import Link from 'components/Link';
import Layout from 'components/Layout';
import Search from 'components/Search';
import { fetchCategories } from 'actions/categories';
import localized from 'router/localized-types';

class HomeApp extends Component {
  static async getInitialProps({ store, lang }) {
    store.dispatch(fetchCategories());
  }

  render() {
    const { categories, ...rest } = this.props;

    return (
      <Layout {...rest}>
        <div className="container my-1">
          <div className="text-left">
            {i18n.t('APP_INDEX_TAGLINE')}{' '}
            <Link route={localized.nl.about_main} className="mr-3">
              {i18n.t('READ_MORE')}&nbsp;›
            </Link>
          </div>
        </div>

        <div className="container my-2">
          <div className="text-left">
            <Search q={rest.url.query && rest.url.query.q} />
          </div>
        </div>

        <div className="container my-3">
          <BoxWhite
            className="rounded my-sm-2 col-sm-12 col-lg-12 bg-ship-light"
            style={{ zIndex: 999 }}>
            <Categories.Browse
              items={categories.items}
              renderer={CategoryLink}
            />
          </BoxWhite>
        </div>
      </Layout>
    );
  }
}

HomeApp.propTypes = {
  categories: PropTypes.object
};
HomeApp.contextTypes = {
  app: PropTypes.string
};

export default connect(({ categories }) => ({
  categories
}))(HomeApp);

const CategoryLink = styled(Link)`
  transition: background 0.2s;
  font-weight: 100;
  color: #eee;

  &:hover {
    background: #444;
    color: #fff;
    text-decoration: none;
  }
`;
